/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {  IGeocodeCachedRequest,  TGeocodeCachedModel,  IMappers,  TGeocodeCachedResponse } from './types'
import type {  IHttpApi,  IHttpApiFetchConfig,  FetchResponse } from '@cian/http-api'
import type {  IPublicGeocodeCachedV1Response } from '../../entities/Geocoding/PublicGeocodeCachedV1Response'


export function createGeocodeCachedModel(parameters: IGeocodeCachedRequest): TGeocodeCachedModel {
return {
v: 1,apiType: 'public',method: 'GET',microserviceName: 'geo',pathApi: '/v1/geocode-cached/',response: {
200: {
contentType: 'json',
},
},request: {
parameters,

},
};
}


export interface IGeocodeCachedOptions<TResponse200>  {
httpApi: IHttpApi;
config?: IHttpApiFetchConfig;
mappers?: IMappers<TResponse200>;
parameters: IGeocodeCachedRequest;

}

export async function fetchGeocodeCached<TResponse200>({
httpApi,
config,
mappers,
parameters,

}: IGeocodeCachedOptions<TResponse200>): Promise<FetchResponse<TGeocodeCachedResponse> | TResponse200> {
const {
statusCode,
response,
headers,

} = (await httpApi.fetch(createGeocodeCachedModel(parameters), config)) as FetchResponse<TGeocodeCachedResponse>;
if (mappers && statusCode in mappers) {
if (statusCode === 200) {
return mappers[200](response as IPublicGeocodeCachedV1Response, headers);
}
}return {
statusCode,
response,
headers,

} as FetchResponse<TGeocodeCachedResponse>;
}

